import { render, staticRenderFns } from "./AddNotes.vue?vue&type=template&id=075cb838&"
import script from "./AddNotes.vue?vue&type=script&lang=js&"
export * from "./AddNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports